// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"50ebf6b9","453":"6cfcf7c8"}[chunkId] + ".chunk.js";
};